import { fetchAPI } from '@bsd/dashboard-toolkit/utils'
import { buildURLQuery } from '../utils'

export const loadTags = async (query) => {
  try {
    let url = '/in/globe3d/tags'
    if (query) {
      url += '?' + buildURLQuery(query)
    }
    return await fetchAPI(url)
  } catch (error) {
    console.log(error)
  }
}
